import request from "@/utils/request";

export function getInfo(data) {
  return request({
    url: "/merchant/merchant/getMerchant",
    method: "post",
    data: data
  });
}

export function getInvoicing(data) {
  return request({
    url: "/merchant/merchant/getBillMsg",
    method: "post",
    params: data
  });
}
export function putInvoicing(data) {
  return request({
    url: "/merchant/merchant/updateBillMsg",
    method: "post",
    data: data
  });
}

// 校验修改信息是否和原信息一致
export function checkInvoicing(data) {
  return request({
    url: "/merchant/merchant/checkMerchant",
    method: "post",
    data: data
  });
}

// 切换服务商登录
export function getSwitchAccount(data) {
  return request({
    url: "/merchant/merchant/switchMerchant",
    method: "post",
    params: data
  });
}
// 修改登录密码
export function putLoginPwd(data) {
  return request({
    url: "/merchant/password",
    method: "post",
    data: data
  });
}

// 修改支付密码
export function putPayPwd(data) {
  return request({
    url: "/merchant/merchant/PayPassword",
    method: "put",
    params: data
  });
}

// api信息
export function getMerchantApiConfigDetail(data) {
  return request({
    url: "/merchant/apiMerchantConfig/getMerchantApiConfigDetail",
    method: "get",
    params: data
  });
}

// api信息-编辑
export function updateMerchantConfig(data) {
  return request({
    url: "/merchant/apiMerchantConfig/updateMerchantConfig",
    method: "post",
    data: data
  });
}

export function getTaxInfo(data) {
  return request({
    url: "/merchant/BillOrderInfo/getTaxByMerchantId",
    method: "post",
    data: data
  });
}

export function getPayMobile(data) {
  return request({
    url: "/merchant/merchant/get/pay/mobile",
    method: "get",
    params: data
  });
}

export function postSeeSecret(data) {
  return request({
    url: "/merchant/apiMerchantConfig/see/secret",
    method: "post",
    data: data
  });
}

// 平台脱敏配置列表
export const desensitizedList = query => {
  return request({
    url: "/merchant/merchantPowerManager/desensitized/list",
    method: "post",
    data: query
  });
};

// 查询账户脱敏设置
export const desensitizedConf = query => {
  return request({
    url: `/merchant/merchantPowerManager/desensitized/conf/${query}`,
    method: "get"
  });
};

// 设置账户脱敏设置
export const setDesensitizedConf = query => {
  return request({
    url: "/merchant/merchantPowerManager/desensitized/conf",
    method: "POST",
    data: query
  });
};

// 本森支付预校验
export const getPreCheck = query => {
  return request({
    url: "/merchant/merchantTaskInfo/batch/pre/pay",
    method: "POST",
    data: query
  });
};

// 本森批量支付
export const batchPay = query => {
  return request({
    url: "/merchant/merchantTaskInfo/submit/batch/pay",
    method: "POST",
    data: query
  });
};
